"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbBData = exports.MbAndroidBData = exports.MbIosBData = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const web_ui_security_1 = require("@gruposantander/web-ui-security");
const baseLibrary_1 = require("../../../libraries/baseLibrary");
const validBDataURLs = (...bdataURLs) => bdataURLs.every(bdataURL => bdataURL && bdataURL.trim());
const changeContextMobile = (context, mobileConnector) => context && mobileConnector.changeAntiFraudContext(context).catch(e => console.error(e));
class MbIosBData extends web_ui_security_1.IosBData {
    constructor(baseUrl, slaveUrl, getMobileConnector) {
        super(baseUrl, slaveUrl);
        this.getMobileConnector = getMobileConnector;
    }
    setContext(context) {
        changeContextMobile(context, this.getMobileConnector());
    }
}
exports.MbIosBData = MbIosBData;
class MbAndroidBData extends web_ui_security_1.AndroidBData {
    constructor(url, getMobileConnector) {
        super(url);
        this.getMobileConnector = getMobileConnector;
    }
    setContext(context) {
        changeContextMobile(context, this.getMobileConnector());
    }
}
exports.MbAndroidBData = MbAndroidBData;
class MbBData extends baseLibrary_1.BaseLibrary {
    constructor(getMobileConnector) {
        super();
        this.getMobileConnector = getMobileConnector;
    }
    isAndroidWithValidURLs() {
        return (0, web_ui_framework_1.isAndroidWebView)() && validBDataURLs(window.BDATA_ANDROID_SEC_URL);
    }
    isIosWithValidURLs() {
        return (0, web_ui_framework_1.isIosWebView)() && validBDataURLs(window.BDATA_IOS_BRID_URL, window.BDATA_IOS_SEC_URL);
    }
    async load() {
        if (this.isAndroidWithValidURLs()) {
            this.instance = new MbAndroidBData(window.BDATA_ANDROID_SEC_URL, this.getMobileConnector);
            await this.instance.load();
        }
        else if (this.isIosWithValidURLs()) {
            this.instance = new MbIosBData(window.BDATA_IOS_BRID_URL, window.BDATA_IOS_SEC_URL, this.getMobileConnector);
            await this.instance.load();
        }
        else if (validBDataURLs(window.BDATA_WEB_URL)) {
            this.instance = new web_ui_security_1.WebBData(window.BDATA_WEB_URL);
            await this.instance.load();
        }
        else {
            web_ui_framework_1.Log.warn('BData: There is no valid BDATA_WEB_URL configured');
        }
    }
}
exports.MbBData = MbBData;
//# sourceMappingURL=index.js.map